/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { theme } from "styles/theme";

export const ColorTag = ({ color }: { color: string }) => {
    return (
        <div
            css={css`
                display: flex;
                align-items: center;
                gap: 8px;
            `}
        >
            <div
                css={css`
                    background-color: ${color};
                    width: 12px;
                    height: 12px;
                    border-radius: 100px;
                    color: ${theme.neutral600};
                    font-weight: 500;
                `}
            />
            <p>{color}</p>
        </div>
    );
};
